import NoteIcon from '@mui/icons-material/Note'
import TextFieldsIcon from '@mui/icons-material/TextFields'
// import LinkIcon from '@mui/icons-material/Link'
// import FormatBoldIcon from '@mui/icons-material/FormatBold'
import ImageIcon from '@mui/icons-material/Image'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import CompareIcon from '@mui/icons-material/Compare'
import ShowChartIcon from '@mui/icons-material/ShowChart'
import ViewStreamIcon from '@mui/icons-material/ViewStream'
import { nanoid } from 'nanoid'

import style from './style.module.scss'
import { DataElement } from '../..'

interface EditorControlsProps {
  onUpdate: (newContent: any) => void
}

const EditorControls = ({ onUpdate }: EditorControlsProps) => {
  const genId = () => nanoid(6)

  const handleAddList = () => {
    onUpdate((prev: DataElement[]) => {
      return [
        ...prev,
        {
          type: 'uiList',
          props: {
            id: genId(),
            numeric: true,
            theme: 'unset',
            title: 'Title',
            items: [
              { title: 'Item 1', description: 'Description 1', list_id: '1' },
              { title: 'Item 2', description: 'Description 2', list_id: '2' },
              { title: 'Item 3', description: 'Description 3', list_id: '3' }
            ]
          }
        }
      ]
    })
  }
  const handleAddTitle = () => {
    onUpdate((prev: DataElement[]) => {
      return [
        ...prev,
        {
          type: 'uiSubtitle',
          props: {
            id: genId(),
            level: 2,
            content: 'Title'
          }
        }
      ]
    })
  }
  const handleAddParagraph = () => {
    onUpdate((prev: DataElement[]) => {
      return [
        ...prev,
        {
          type: 'uiParagraph',
          props: {
            id: genId(),
            content: 'Paragraph'
          }
        }
      ]
    })
  }
  const handleAddImage = () => {
    onUpdate((prev: DataElement[]) => {
      return [
        ...prev,
        {
          type: 'uiImage',
          props: {
            id: genId(),
            src: 'https://picsum.photos/200',
            alt: 'Image'
          }
        }
      ]
    })
  }

  const handleAddCompare = () => {
    onUpdate((prev: DataElement[]) => {
      return [
        ...prev,
        {
          type: 'uiCompare',
          props: {
            id: genId(),
            inset: false,
            img1: 'https://picsum.photos/200',
            img2: 'https://picsum.photos/300',
            alt1: 'Image 1',
            alt2: 'Image 2'
          }
        }
      ]
    })
  }

  const handleAddIncrease = () => {
    onUpdate((prev: DataElement[]) => {
      return [
        ...prev,
        {
          type: 'uiIncrease',
          props: {
            id: genId(),
            value: '75.2',
            label: 'in average revenue per paying user (ARPPU)'
          }
        }
      ]
    })
  }

  const handleAddNote = () => {
    onUpdate((prev: DataElement[]) => {
      return [
        ...prev,
        {
          type: 'uiNote',
          props: {
            id: genId(),
            theme: 'unset',
            title: 'Note Title',
            description: 'Note Description',
            icon: 'quote',
            bigIcon: false
          }
        }
      ]
    })
  }
  const handleAddMetric = () => {
    onUpdate((prev: DataElement[]) => {
      return [
        ...prev,
        {
          type: 'uiMetric',
          props: {
            id: genId(),
            description: 'Metric Description',
            theme: 'unset',
            metrics: [
              { label: 'Metric 1', value: 'Value 1' },
              { label: 'Metric 2', value: 'Value 2' }
            ]
          }
        }
      ]
    })
  }

  return (
    <div className={style.content_controls}>
      <button onClick={handleAddParagraph} title="Paragraph">
        <TextFieldsIcon />
      </button>
      <button onClick={handleAddTitle} title="Heading">
        H1
      </button>
      {/* <button title="Bold">
        <FormatBoldIcon />
      </button>
      <button title="Link">
        <LinkIcon />
      </button> */}
      <button onClick={handleAddImage} title="Image">
        <ImageIcon />
      </button>
      <button onClick={handleAddList} title="List">
        <FormatListBulletedIcon />
      </button>
      <button onClick={handleAddNote} title="Note">
        <NoteIcon />
      </button>
      <button onClick={handleAddCompare} title="Compare">
        <CompareIcon />
      </button>
      <button onClick={handleAddIncrease} title="Increase">
        <ShowChartIcon />
      </button>
      <button onClick={handleAddMetric} title="Metric">
        <ViewStreamIcon />
      </button>
    </div>
  )
}

export default EditorControls
